const generator = require("./warehousepurchase-fullcont-multitable-generator");
// const timeDate         = require ('../../../../../js-handler/time-date')

export function start(detail) {
  console.log("gmt>", detail);

  obj[detail.act].start(detail);
} /**/

const obj = {
  add: {
    start: (detail) => {
      add(detail);
    },
  },
};

//add line
function add(detail) {
  console.log("MULTITABLE ADD>", detail);
  purchaseMT.forEach((mt) => {
    // console.log(mt)
    if (mt.tableName === detail.tableName) {
      //se agrego propiedad de tab para validar si se esta creando el la linea por medio del boton tab
      //si es asi pues solo has un focus
      if (detail.tab == undefined) {
        mt.add();
      } else {
        mt.add(detail.tab);
      }
    } /*if*/
  });
}

export const purchaseMT = [
  {
    tableName: "purchase_vs_item",
    value: "",
    id: "purchase_form_purchase_vs_item",
    html: "",
    data: [],
    dataCopy: [],
    oneRequired: false,
    fields: [
      { name: "item_id", type: "autocomplete", html: "", required: true },

      { name: "type_selling", type: "autocomplete", html: "", required: true },

      { name: "qty", type: "textfield", html: "", required: false },

      { name: "unit_price", type: "textfield", html: "", required: false },

      { name: "selling_price", type: "textfield", html: "", required: true },

      { name: "total_price", type: "textfield", html: "", required: true },

      { name: "cogs_row_amount", type: "textfield", html: "", required: false },
    ],

    generator: function (line) {
      return generator.purchase_vs_item(line.id);
    },

    add: function (tab = false) {
      const newLine = generator.purchase_vs_item("");
      this.html.insertAdjacentHTML("beforeend", newLine);

      const allLines = this.html.querySelectorAll(".item_id");
      const lastLine = allLines[allLines.length - 1];
      const targetInput = lastLine.querySelector("input");

      targetInput.focus();
      if (!tab) {
        targetInput.click();
      }

      //console.log("targetInput %%%%%%%%%%%%%%%%%%%%%%", targetInput);
    },
  },
];
